module.exports = __webpack_public_path__ + "static/media/6.5d0be55a.mp3";